import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ProposalHistory from "@/pages/ProposalHistory";
export const Route = createFileRoute("/history")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><ProposalHistory /></ProtectedRoute>) });
